module.exports = "<div class=map-view> <div id=map class=\"map full-size\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/views/post-view-map.html
// module id = 745
// module chunks = 0